import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RechnerPageRoutingModule } from './rechner-routing.module';
import { RechnerPage } from './rechner.page';
import { RIDEFahrradComponent } from './ride-fahrrad/ride-fahrrad.component';
import { RIDEBeschaefigungsmerkmaleComponent } from './ride-beschaefigungsmerkmale/ride-beschaefigungsmerkmale.component';
import { RIDESchutzLeistungComponent } from './ride-schutz-leistung/ride-schutz-leistung.component';
import { RIDELeasingRahmenbedingungenComponent } from './ride-leasing-rahmenbedingungen/ride-leasing-rahmenbedingungen.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { DialogComponent } from './dialog/dialog.component';
import { CdkTableModule } from '@angular/cdk/table';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatTooltipModule} from '@angular/material/tooltip';
@NgModule({
	imports: [
		CommonModule,
		IonicModule,
		RechnerPageRoutingModule,
		ReactiveFormsModule,
		FormsModule,
		FontAwesomeModule,
		MatDialogModule,
		MatInputModule,
		CdkTableModule,
		MatAutocompleteModule,
		MatTooltipModule,
	],
    declarations: [
        RechnerPage,
        RIDEFahrradComponent,
        RIDEBeschaefigungsmerkmaleComponent,
        RIDESchutzLeistungComponent,
        RIDELeasingRahmenbedingungenComponent,
        DialogComponent,
    ],
  exports: [
    RIDEFahrradComponent,
    RIDEFahrradComponent,
    RIDEBeschaefigungsmerkmaleComponent,
    RIDEFahrradComponent,
    DialogComponent,
  ],
  providers: [],
})
export class RechnerPageModule {}
